<!--
Copyright 2017 ODK Central Developers
See the NOTICE file at the top-level directory of this distribution and at
https://github.com/getodk/central-frontend/blob/master/NOTICE.

This file is part of ODK Central. It is subject to the license terms in
the LICENSE file found in the top-level directory of this distribution and at
https://www.apache.org/licenses/LICENSE-2.0. No part of ODK Central,
including this file, may be copied, modified, propagated, or distributed
except according to the terms contained in the LICENSE file.
-->
<template>
  <tr class="project-row" :class="{ archived: project.archived }">
    <td>
      <div class="name">
        <router-link :to="projectPath(project.id)">
          <span>{{ project.nameWithArchived() }}</span>
          <span class="icon-angle-right"></span>
        </router-link>
      </div>
      <div v-if="introduction">
        <a href="#" @click.prevent="$emit('show-introduction')">
          {{ $t('help') }}
        </a>
      </div>
    </td>
    <td>{{ $tcn('count.form', project.forms) }}</td>
    <td>
      <date-time :iso="project.lastSubmission" :blank="$t('noSubmission')"/>
    </td>
  </tr>
</template>

<script>
import DateTime from '../date-time.vue';
import routes from '../../mixins/routes';

export default {
  name: 'ProjectRow',
  components: { DateTime },
  mixins: [routes()],
  props: {
    project: {
      type: Object,
      required: true
    },
    introduction: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss">
.project-row {
  .table tbody & td { vertical-align: middle; }

  &.archived { color: #999; }

  .name {
    a {
      font-size: 24px;

      &, &:hover, &:focus {
        color: inherit;
        text-decoration: none;
      }
    }

    .icon-angle-right {
      font-size: 20px;
      margin-left: 9px;
    }
  }
}
</style>

<i18n lang="json5">
{
  "en": {
    "help": "What are Projects?",
    // This text is shown under the "Latest Submission" column of the Projects
    // table. It is shown for a Project with no Submissions.
    "noSubmission": "(none)"
  }
}
</i18n>

<!-- Autogenerated by destructure.js -->
<i18n>
{
  "cs": {
    "help": "Co jsou Projekty?",
    "noSubmission": "(žádné)"
  },
  "de": {
    "help": "Was sind Projekte?",
    "noSubmission": "(keine)"
  },
  "es": {
    "help": "¿Qué son los Proyectos?",
    "noSubmission": "(ninguno)"
  },
  "fr": {
    "help": "Que sont les \"Projets\" ?",
    "noSubmission": "(aucune)"
  }
}
</i18n>
